var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_541_1633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_541_1633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20C11.5667 20 10.6875 19.8542 9.8625 19.5625C9.0375 19.2708 8.28333 18.8583 7.6 18.325L6.2 19.7C6.01667 19.8833 5.78333 19.975 5.5 19.975C5.21667 19.975 4.98333 19.8833 4.8 19.7C4.61667 19.5167 4.525 19.2833 4.525 19C4.525 18.7167 4.61667 18.4833 4.8 18.3L6.175 16.925C5.64167 16.2417 5.22917 15.4833 4.9375 14.65C4.64583 13.8167 4.5 12.9333 4.5 12C4.5 9.76667 5.275 7.875 6.825 6.325C8.375 4.775 10.2667 4 12.5 4H20.5V12C20.5 14.2333 19.725 16.125 18.175 17.675C16.625 19.225 14.7333 20 12.5 20ZM12.5 18C14.1667 18 15.5833 17.4167 16.75 16.25C17.9167 15.0833 18.5 13.6667 18.5 12V6H12.5C10.8333 6 9.41667 6.58333 8.25 7.75C7.08333 8.91667 6.5 10.3333 6.5 12C6.5 12.65 6.6 13.2708 6.8 13.8625C7 14.4542 7.275 14.9917 7.625 15.475L12.8 10.3C12.9833 10.1167 13.2167 10.025 13.5 10.025C13.7833 10.025 14.0167 10.1167 14.2 10.3C14.4 10.5 14.5 10.7375 14.5 11.0125C14.5 11.2875 14.4 11.525 14.2 11.725L9.025 16.9C9.50833 17.25 10.0458 17.5208 10.6375 17.7125C11.2292 17.9042 11.85 18 12.5 18Z",
    fill: "#198243"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.93ed6f5875ae20bdd90c618f04087f74.svg";
export { ForwardRef as ReactComponent };